<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovação de produto
    </template>
    <template>
      <px-aprovacao-compra-detalhes-produto v-if="dialog"
                                            is-modal-view
                                            :item-id-prop="itemId"
                                            :aprovacao-id-prop="aprovacaoId"
                                            :fornecedor-id="fornecedorId"
                                            @update="onUpdate"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import AprovacaoCompraDetalhesProduto
  from '@/modules/aprovacao-compra/detalhes-produtos/AprovacaoCompraDetalhesProduto.vue';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
    },
    fornecedorId: {
      type: [String, Number],
    },
    itemId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '1280px';
    },
  },
  methods: {
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoCompraDetalhesProduto: AprovacaoCompraDetalhesProduto,
  },
};
</script>
